import FormService from "@/services/FormService";
import ContentServiceV2 from "@/services/ContentServiceV2";

export default {
  data() {
    return {
      contentService: new ContentServiceV2(),

      submissionId: null,
      submittingFiles: false,
      signedUrls: [],
    };
  },
  methods: {
    async uploadSubmissionFiles(formSubmissionId, files, onSuccess) {
      if (!files || !files.length) {
        return;
      }

      this.submissionId = formSubmissionId;
      this.submittingFiles = true;

      try {
        // Fetch all signed URLs upfront
        this.signedUrls = await this._getSignedUrls(formSubmissionId, files);

        await this._processFiles(files);
        if (onSuccess) await onSuccess();
      } catch (error) {
        console.error("Failed to fetch signed URLs:", error);
        this._handleUploadError(error, true);
      }
    },

    async _processFiles(files) {
      const results = await Promise.allSettled(
        files.map(async (file, index) => {
          const signedUrl = this.signedUrls[index];
          if (!signedUrl) {
            throw new Error("No signed URL available for file");
          }

          console.log(`Uploading file: ${file.name}`);

          await this.contentService
            .uploadContentWithSignedUrl(signedUrl, file, true, {
              silent: true,
            })
            .catch((error) => {
              console.error("Failed to upload file:", { error, file });
              throw { error, file };
            });

          console.log(`Successfully uploaded: ${file.name}`);

          return {
            index,
            signedUrl,
            file,
          };
        })
      );

      this.submittingFiles = false;

      // Throw snackbar up if any files failed to upload
      if (results.some((r) => r.status === "rejected")) {
        const formattedFailedFileNames = results
          .filter((r) => r.status === "rejected")
          .map((r) => r.reason?.file?.name)
          .join(", ");
        this.$store.dispatch("showSnackbar", {
          text: `The following files failed to upload: ${formattedFailedFileNames}`,
          color: "error",
          timeout: 6000,
        });
      }

      return results;
    },

    // This should only be used if we fail to generate signed URLs
    _handleUploadError(error) {
      console.error("Upload error:", error);
      this.submittingFiles = false;

      let errorMessage;
      if (error?.response?.status === 413) {
        errorMessage = "The file you submitted was too large. We have a limit of 50 MB per upload.";
      } else {
        errorMessage =
          "There was an issue uploading your files. Please try again or contact us if you need further assistance.";
      }

      this.$store.dispatch("showSnackbar", {
        text: errorMessage,
        color: "error",
      });
    },

    async _getSignedUrls(submissionId, files) {
      const fileRes = await FormService.createFormSubmissionFileUploadV2(
        submissionId,
        files.map((file) => ({
          fileName: file.name || "unknown",
          fileSize: file.size,
        }))
      );

      const signedUrls = fileRes?.result?.map((r) => r?.url);
      if (!signedUrls?.length) {
        throw new Error("No signed URLs received");
      }

      return signedUrls;
    },
  },
};
